export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
